import { createGtm } from "@gtm-support/vue-gtm"
import { LOCALE } from "~/constants/locale"

export default defineNuxtPlugin(nuxtApp => {
  if (import.meta.client) {
    const config = useRuntimeConfig()

    nuxtApp.vueApp.use(
      createGtm({
        id:
          (nuxtApp.$i18n.locale.value === LOCALE.SPAIN
            ? config.public.gtm.id_es
            : nuxtApp.$i18n.locale.value === LOCALE.US
                ? config.public.gtm.id_us
                : config.public.gtm.id) || "GTM-XXXXXX",
        enabled: Boolean(
          config.public.gtm.id_es || config.public.gtm.id_us || config.public.gtm.id || config.public.gtm.debug === "true"
        ),
        debug: config.public.GOOGLE_TAG_MANAGER_DEBUG === "true",
        defer: true
      })
    )
  }
})
